module.exports = __webpack_public_path__ + "img/daycare_thumbnail-600x450.073318ac.jpg";